<template>
  <section class="bonus box-card">
    <div class="item">
      <p>旧机估价</p>
      <p class="clearfix">
        <span>{{order.oldname}}</span>
        <span>-¥{{order.oldamount}}</span>
      </p>
    </div>
    <div class="item">
      <p>换机福利</p>
      <p class="clearfix">
        <span>环保补助金</span>
        <span>-¥{{product.bonus_price}}</span>
      </p>
      <p class="clearfix" v-if="bonus.value">
        <span>环保优惠券</span>
        <span>-¥{{bonus.value}}</span>
      </p>
    </div>
  </section>
</template>

<script>
export default {
    props:["order","product","bonus"]
};
</script>

<style scoped>
.box-card {
  width: 3.49rem;
  margin: 0.16rem auto 0rem;
  box-shadow: 0rem 0rem 0.04rem rgba(134, 130, 130, 0.3);
  background: #fff;
  border-radius: 0.05rem;
  padding: 0.14rem 0.16rem;
  position: relative;
}
.box-card .item p:nth-child(1) {
  color: #999;
  position: relative;
  padding: 0 0 0 0.35rem;
  margin-bottom:0.1rem;
}
.box-card .item p:nth-child(2),.box-card .item p:nth-child(3) {
  color: #000;
  margin-top:0.1rem;
}
.box-card .item p:nth-child(2) span:nth-child(1),.box-card .item p:nth-child(3) span:nth-child(1){
    float: left;
}

.box-card .item p:nth-child(2) span:nth-child(2),.box-card .item p:nth-child(3) span:nth-child(2){
    float: right;
    color: #F94C66;
}
.box-card .item p:nth-child(1):before {
  width: 0.26rem;
  height: 0.26rem;
  content: "";
  display: inline-block;
  background: url(../../../assets/image/content_phone.png) no-repeat;
  background-size: 100%;
  position: absolute;
  left:0;
  top:-0.03rem;
}
.box-card .item:nth-child(2) p:nth-child(1):before {
  background: url(../../../assets/image/bonusTitleBg.png) no-repeat;
  background-size: 100%;
}
.box-card .item:nth-child(2){
    margin-top:0.3rem;
}
</style>
